var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"inline-toggle pull-right\">\n<strong>New Comfort Bid Design</strong>\n<pkp-toggle ng-model=\"$ctrl.migratedComfortBids.newComfortBidDesign\" ng-click=\"$ctrl.migratedComfortBids.activate({\n            comfortBidId: $ctrl.comfortBidId,\n        })\" uib-tooltip=\"You can switch back as long as the test phase is live.\" tooltip-placement=\"bottom\"></pkp-toggle>\n</div>\n";
var id1="app/comfort-bid/comfort-bid-wizard-toggle.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;